"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EliteFitnessPerformance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="222152" id="discover-your-pleasure" className="dark bg-background text-foreground relative min-h-[80vh] flex items-center justify-center overflow-hidden py-24 lg:py-32 bg-gradient-to-br from-[hsl(240,5%,10%)] to-[hsl(240,50%,50%)]">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none z-0 overflow-hidden">
        <span className="text-[28vw] font-default font-bold text-white/[0.03] leading-none tracking-tighter whitespace-nowrap transform translate-y-12">
          DESIRE
        </span>
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-5xl sm:text-6xl md:text-[70px] leading-[1.1] uppercase mb-6 text-white drop-shadow-2xl tracking-tighter">
          The Art of Modern
          <span className="block text-primary mt-2 sm:mt-4">
            Intimacy
          </span>
        </h1>

        <p className="font-default text-base sm:text-[18px] text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Explore the intersection of wellness, connection, and empowerment. Our curated guides redefine the landscape of pleasure for the modern individual.
        </p>

        <Button asChild size="lg" className="rounded-full bg-primary text-white hover:bg-primary hover:scale-105 hover:shadow-xl transition-all duration-400 h-14 px-10 text-lg font-default uppercase tracking-wider border-none">
          <Link to="/AboutPage">Explore The Playbook</Link>
        </Button>
      </div>
    </section>;
}